import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {DialogComponent} from "@syncfusion/ej2-angular-popups";
import {$translate} from "../../services/internationalization/localize.service";
import {ButtonPropsModel} from "@syncfusion/ej2-popups/src/dialog/dialog-model";
import {RequestService} from "../../services/request/request.service";
import {FeatureFlagsService} from "../../services/feature-flag/feature-flags.service";
import {UtilService} from "../../services/util/util.service";
import {InternationalizationService} from "../../services/internationalization/internationalization.service";
import {InternationalizationFieldValue} from "../../services/internationalization/internationalization-field-value";

@Component({
  selector: 'sb-locale-html-configuration',
  templateUrl: './locale-html-configuration.component.html',
  styleUrls: ['./locale-html-configuration.component.scss']
})
export class LocaleHtmlConfigurationComponent implements OnInit {

  @Input()
  editorElement: HTMLElement;

  @Input()
  fieldDefinition: any;

  @Input()
  fieldViewModel: any;

  @Input()
  record: any;

  @Input()
  rendererProperties: any;

  // Return a thunk that shows the modal
  @Input()
  get showDialog() {
    const self = this;
    return () => {
      self.modalShowDialog();
    };
  }

  // Dialog support

  @ViewChild('modalDialog', {static: false})
  ejDialog: DialogComponent;

  public modalTitle: string = $translate("ng.component.locale-html-configuration.title")`Configure localization`;

  public modalVisible = false;

  public modalPosition: any = { X: 'center', Y: 'center' };

  public modalButtons: ButtonPropsModel[] = [
    {
      'click': this.modalHideDialog.bind(this, false),
      buttonModel: {
        content: $translate("ng.component.locale-html-configuration.button.cancel")`Cancel`,
      }
    },
    {
      'click': this.modalHideDialog.bind(this, true),
      buttonModel: {
        content: $translate("ng.component.locale-html-configuration.button.save")`Save`,
        isPrimary: true,
      }
    },
  ];

  i18nKey;

  originalI18nKey;

  i18nKeyPlaceholder = $translate('ng.component.locale-html-configuration.placeholder')`Enter internationalization key`;

  i18nKeyGenerateTitle =  $translate('ng.component.locale-html-configuration.button.generate')`Generate key`;

  i18nKeyAssignTitle =  $translate('ng.component.locale-html-configuration.button.assign')`Assign key`;

  i18nKeyRevertTitle =  $translate('ng.component.locale-html-configuration.button.revert')`Revert key`;

  @ViewChild('i18nKeyInput', {static: false}) i18nKeyInput: HTMLInputElement;

  constructor(private requestService: RequestService,
              public hostElement: ElementRef,
              public featureFlagsService: FeatureFlagsService,
              public i18nService: InternationalizationService,
              public utilService: UtilService) { }

  ngOnInit(): void {
  }

  public async modalHideDialog(save: boolean) {
    this.ejDialog.hide();

    if (save) {
      const editor = ($(this.editorElement) as any)?.tinymce();
    }
  }

  public modalShowDialog() {
    if (this.ejDialog) {
      this.ejDialog.show();
      this.utilService.tickThen(() => {
        this.refresh();
      })
    }
  }

  private refresh() {
    let currentKey = this.fieldViewModel.value();
    let tableName = this.record._tableClass();
    let fieldName = this.fieldViewModel.getName();

    if (currentKey == null || typeof currentKey == "string") {
      if (currentKey == null) {
        currentKey = this.i18nService.generateDefaultKey(tableName, fieldName);
      }
    } else {
      const currentFieldValue = currentKey as InternationalizationFieldValue;
      currentKey = currentFieldValue.i18nKey;
    }

    this.i18nKey = currentKey;
    this.originalI18nKey = this.i18nKey;
  }

  i18nKeyGenerate($event: any) {
    let tableName = this.record._tableClass();
    let fieldName = this.fieldViewModel.getName();
    this.i18nKey = this.i18nService.generateDefaultKey(tableName, fieldName)
  }

  i18nKeyAssign($event: any) {
    this.i18nKey = this.i18nKeyInput.value;
  }

  i18nKeyRevert($event: any) {
    this.i18nKey = this.originalI18nKey;
  }
}
